// Third-party
import React from 'react';
import classNames from 'classnames';

type Props = {
  colors: string[];
  selected?: string;
  onChange?: (color: string) => void;
  disabled?: boolean;
};

class ColorSelector extends React.PureComponent<Props> {
  render() {
    const { colors, onChange, selected, disabled } = this.props;

    return (
      <div className={classNames('color-selector', { disabled })}>
        {colors.map(color => (
          <button
            type="button"
            key={color}
            className={classNames('color-square', { selected: selected === color })}
            style={{ background: color }}
            onClick={() => !disabled && onChange && onChange(color)}
          />
        ))}
      </div>
    );
  }
}

export default ColorSelector;
